import React from "react";
import PropTypes from "prop-types";
import { BVRatingStar } from "./BVRatingStar";
import * as styles from "./BVRatingStars.css";
import { cx } from "emotion";

export class BVRatingStars extends React.Component {
    mapStars = () => {
        const { onSelect, onHover, selectedStar, hoveredStar } = this.props;
        const starsArray = [0, 1, 2, 3, 4];

        return starsArray.map((el, index) => {
            const starIndex = index + 1;
            const isActive = hoveredStar
                ? starIndex <= hoveredStar
                : starIndex <= selectedStar;

            return (
                <BVRatingStar
                    key={index}
                    onHover={value => onHover(value)}
                    onClick={() => {
                        onSelect(starIndex);
                    }}
                    active={isActive}
                    activeStarsCount={hoveredStar || selectedStar}
                    index={starIndex}
                />
            );
        });
    };

    render() {
        const stars = this.mapStars();
        const { className } = this.props;

        return (
            <div className={cx(styles.starsBarContainer, className)}>
                {stars.map(star => star)}
            </div>
        );
    }
}

BVRatingStars.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired,
    selectedStar: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hoveredStar: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};